import { createIcon } from './icon-utils';

export const CrossIcon = createIcon({
  path: 'M7.5 13.374c.345 0 .625-.28.625-.625v-4.9h4.899a.625.625 0 1 0 0-1.25h-4.9V1.7a.625.625 0 1 0-1.25 0v4.9H1.976a.625.625 0 1 0 0 1.25h4.9v4.899c0 .345.28.625.625.625z',
  viewBox: '0 0 15 15',
});
